<canvas ref="pieChart"></canvas>

<script>
import { Pie } from "vue-chartjs";
import { ColorUtil } from '@/utils/colorUtil';

export default {
  name: "PieChart",
  extends: Pie,
  props: {
    title: {
      type: String,
      required: true,
    },
    legendPosition: {
      type: String,
      default: () => "bottom",
    },
    data: {
      type: Array,
      required: true,
    },
    labels: {
      type: Array,
      required: true,
    },
  },
  watch: {
    data: "renderPieChart",
    labels: "renderPieChart",
    title: "renderPieChart",
    legendPosition: "renderPieChart",
  },
  mounted() {
    this.renderPieChart();
  },
  methods: {
    renderPieChart() {
      const chartData = {
        labels: this.labels,
        datasets: [
          {
            backgroundColor: ColorUtil.generateColors(this.data.length),
            borderColor: "#333",
            borderWidth: 0.5,
            data: this.data,
          },
        ],
      };

      const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: false,
          text: this.title,
          fontSize: 18,
          fontColor: "#333",
          position: "top",
        },
        legend: {
          position: this.legendPosition,
          labels: {
            fontColor: "#333",
            usePointStyle: true,
            // No need to override generateLabels unless needed, can keep default styling:
            // generateLabels: function(chart) { ... }
          },
        },
      };

      this.renderChart(chartData, chartOptions);
    },
  },
};
</script>

<style scoped>
canvas {
  height: 250px !important;
  padding-bottom: 10px;
}
</style>
